// pages/VKQuestions.js
import VKTemplate from "../components/VKTemplate";

export default function VKQuestions() {
  return (
    <VKTemplate
      api="https://api.virtualkalvi.com/vkQuestions"
      mapItem={(result) =>
        result.questions.map(q => ({
          title: q.question,
          subtitle: q.subject,
          updated: q.updated_ago,
          link: q.link
        }))
      }
    />
  );
}